// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608111458/js/" + chunkId + "." + {"44":"6cf8053c","225":"7a2786db","481":"412085f1","486":"a7f06e06","770":"91c236d2"}[chunkId] + ".0.9597508310726052.chunk.js";
};